import { Component, EventEmitter, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalModule, FormLabelModule } from "wspowerpack";
import { ReactiveFormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormRepoService } from "../services/form-repo.service";
import {
  CostCodeClient,
  CostCodeSearchV1Model,
  CostCodeV1Model,
  CostReportSearchV1Model,
  EmployeeClient,
  EmployeeV1Model,
  JobClient,
  JobV1Model,
  SkillLevelClient,
  SkillLevelV1Model,
} from "src/app/api/client";

@Component({
  selector: "app-job-selector-modal",
  standalone: true,
  imports: [CommonModule, ModalModule, ReactiveFormsModule, FormLabelModule],
  templateUrl: "./job-selector-modal.component.html",
  styleUrls: ["./job-selector-modal.component.scss"],
})
export class JobSelectorModalComponent {
  @Output() submitCompletedEvent = new EventEmitter<CostCodeSearchV1Model>();

  jobForm = this.formRepoService.selectJobForm();
  jobs: JobV1Model[] = [];
  employees: EmployeeV1Model[] = [];
  costCodes: CostCodeV1Model[] = [];
  skillLevels: SkillLevelV1Model[] = [];
  constructor(
    public activeModal: NgbActiveModal,
    private formRepoService: FormRepoService,
    private jobClient: JobClient,
    private costCodeClient: CostCodeClient,
    private skillLevelClient: SkillLevelClient,
    private employeeClient: EmployeeClient
  ) {}

  ngOnInit(): void {
    this.jobClient.getActive().subscribe((data) => {
      this.jobs = data;
    });
    this.employeeClient.getAll().subscribe((data) => {
      this.employees = data;
    });
    this.costCodeClient.getAll().subscribe((data) => {
      this.costCodes = data;
    });
    this.skillLevelClient.getAll().subscribe((data) => {
      this.skillLevels = data;
    });
  }

  onConfirm(): void {
    if (this.jobForm.invalid) {
      return;
    }

    const model = new CostReportSearchV1Model();
    model.jobId = this.jobForm.controls["jobId"].value;
    model.employeeId = this.jobForm.controls["employeeId"].value;
    model.costCodeId = this.jobForm.controls["costCodeId"].value;
    model.startDate = this.jobForm.controls["startDate"].value;
    model.endDate = this.jobForm.controls["endDate"].value;
    model.skillLevelId = this.jobForm.controls["skillLevelId"].value;

    if (model.startDate === "") {
      model.startDate = null;
    }
    if (model.endDate === "") {
      model.endDate = null;
    }

    this.submitCompletedEvent.emit(model);
    this.activeModal.close();
  }

  onCancel(): void {
    this.activeModal.close();
  }

  clearField(field: string) {
    console.log("Clearing field " + field);
    this.jobForm.controls[field].reset("");
  }
}
